import {DateTime} from "@webmate-web-core/shared/types/base-types";
import {ChannelName, CustomerId, NotificationId, NotificationScope, UserId} from "@webmate-web-core/shared/types/ids";

export interface ChannelInfo {
    customer: CustomerId;
    owner: any;
    name: ChannelName;
    enabled: boolean;
    lastSeen: DateTime;
    topicFilter: Array<Topic>;
}
export type Topic = 'maintenance' | 'release' | 'marketing' | 'organization';

export interface UserNotification {
    id: NotificationId;
    scope: NotificationScope;
    body: any;
    topicName: Topic;
    creationTime: DateTime;
    creator: UserId | undefined;
}

export type AvailableTopics = Array<{value: Topic, label: string}>;

export const WmAdminTopics: AvailableTopics = [{value: 'maintenance', label: 'Maintenance'}, {value: 'release', label: 'Release'}, {value: 'marketing', label: 'Guides & Showcases'}];

export const OrgAdminTopics: AvailableTopics = [{value: 'organization', label: 'Organization'}];

export function isWmAdminNotification(userNotification: UserNotification ): boolean {
    return WmAdminTopics.some(data => data.value === userNotification.topicName);
}

